import React from "react";
import Section from "../../Section";
import AppointmentSection from "../../Section/AppointmentSection";
import SectionHeading from "../../SectionHeading";
import Spacing from "../../Spacing";
import { pageTitle } from "../../../helpers/PageTitle";

const FreeClearAlignerCaseEvaluation = () => {
  pageTitle("Free Clear Aligner Case Evaluation");
  return (
    <>
      <Section className="cs_footer_margin_0">
        <div
          className="cs_banner cs_style_4 cs_bg_filed overflow-hidden text-center"
          style={{
            backgroundImage: `url(/images/about/free.png)`,
            minHeight: '75vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px',
            position: 'relative',
            backgroundPosition: '24%',
            marginTop: '85px',
            backgroundSize: 'contain !important',
          }}
        >
          
        </div>
      </Section>

      <Section topMd={100} topLg={80} topXl={60}>
        <div className="container">
          <SectionHeading title="Our Workflow" titleUp="" center={true} />
          <Spacing md="40" lg="30" />
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <ol className="cs_fs_20 cs_heading_color" style={{ lineHeight: '1.8' }}>
                <li className="mb-3"><b>Case Submission:</b> We receive and review all patient records and the prescribed treatment plan.</li>
                <li className="mb-3"><b>Clinical Case Assessment:</b> Our dedicated orthodontist evaluates and classifies the case complexity (Simple, Moderate, or Complex).</li>
                <li className="mb-3"><b>Treatment Plan Delivery (Within 24 Hours):</b> A comprehensive digital treatment plan is prepared and delivered to your registered email within 24 hours of case submission.</li>
                <li className="mb-3"><b>Approval & Manufacturing Files:</b> Upon your approval, the final STL files required for aligner manufacturing or 3D printing are delivered promptly.</li>
              </ol>
            </div>
          </div>
        </div>
      </Section>


      <Section
        topMd={100}
        topLg={80}
        topXl={60}
        bottomMd={190}
        bottomLg={145}
        bottomXl={110}
        id="appointment"
      >
        <AppointmentSection
          sectionTitle="Appointment"
          sectionTitleUp="BOOK AN"
          imgUrl="/images/home_1/appointment.jpeg"
          departmentId="free-clear-aligner-case-evaluation"
        />
      </Section>
    </>
  );
};

export default FreeClearAlignerCaseEvaluation;
